import { BackendErrorPayload } from '@paywithextend/components/dist/error.utils'
import axios from 'axios'
import queryString from 'query-string'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { GetUserConnectionsQueryParams } from 'src/app/PeopleContacts/redux/peopleContacts.actions'
import { PeopleInvitedToOrgResponse } from 'src/models/people.models'
import { RootState } from 'src/redux/createRootReducer'
import { selectAuthedJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'

export const GET_INVITED_PEOPLE_INIT =
  'app/people/peopleInvitedToOrg/GET_INVITED_PEOPLE_INIT'
export const GET_INVITED_PEOPLE_SUCCESS =
  'app/people/peopleInvitedToOrg/GET_INVITED_PEOPLE_SUCCESS'
export const GET_INVITED_PEOPLE_FAILURE =
  'app/people/peopleInvitedToOrg/GET_INVITED_PEOPLE_FAILURE'

export type GetPeopleInvitedToOrgSuccessPayload = PeopleInvitedToOrgResponse

export type GetPeopleInvitedToOrgFailurePayload = BackendErrorPayload<string>

export interface GetPeopleInvitedToOrgInitAction {
  type: typeof GET_INVITED_PEOPLE_INIT
}
export interface GetPeopleInvitedToOrgSuccessAction {
  type: typeof GET_INVITED_PEOPLE_SUCCESS
  payload: GetPeopleInvitedToOrgSuccessPayload
}
export interface GetPeopleInvitedToOrgFailureAction {
  type: typeof GET_INVITED_PEOPLE_FAILURE
  payload: GetPeopleInvitedToOrgFailurePayload
}

export type GetPeopleInvitedToOrgActions =
  | GetPeopleInvitedToOrgInitAction
  | GetPeopleInvitedToOrgSuccessAction
  | GetPeopleInvitedToOrgFailureAction

const createGetPeopleInvitedToOrgInitAction =
  (): GetPeopleInvitedToOrgInitAction => ({
    type: GET_INVITED_PEOPLE_INIT,
  })
const createGetPeopleInvitedToOrgSuccessAction = (
  payload: GetPeopleInvitedToOrgSuccessPayload,
): GetPeopleInvitedToOrgSuccessAction => ({
  type: GET_INVITED_PEOPLE_SUCCESS,
  payload,
})
const createGetPeopleInvitedToOrgFailureAction = (
  payload: GetPeopleInvitedToOrgFailurePayload,
): GetPeopleInvitedToOrgFailureAction => ({
  type: GET_INVITED_PEOPLE_FAILURE,
  payload,
})

export const getInvitedPeople = (
  organizationId: string,
  queryParameters?: GetUserConnectionsQueryParams,
): ThunkAction<
  Promise<
    GetPeopleInvitedToOrgFailureAction | GetPeopleInvitedToOrgSuccessAction
  >,
  RootState,
  void,
  GetPeopleInvitedToOrgActions
> => {
  return async (
    dispatch: ThunkDispatch<RootState, void, GetPeopleInvitedToOrgActions>,
    getState: () => RootState,
  ): Promise<
    GetPeopleInvitedToOrgFailureAction | GetPeopleInvitedToOrgSuccessAction
  > => {
    dispatch(createGetPeopleInvitedToOrgInitAction())
    return axios
      .get<GetPeopleInvitedToOrgSuccessPayload>(
        `/organizations/${organizationId}/invites?${queryParameters ? queryString.stringify(queryParameters) : ''}`,
        selectAuthedJsonApiRequestConfig(getState()),
      )
      .then(
        async (response) => {
          return dispatch(
            createGetPeopleInvitedToOrgSuccessAction(response.data),
          )
        },
        (err) => {
          return dispatch(
            createGetPeopleInvitedToOrgFailureAction(err.response.data),
          )
        },
      )
  }
}

export const REMOVE_ORGANIZATION_INVITE =
  'app/people/peopleInvitedToOrg/REMOVE_ORGANIZATION_INVITE'

export interface RemoveOrganizationInviteAction {
  type: typeof REMOVE_ORGANIZATION_INVITE
  payload: string
}

export const removeOrganizationInvite = (
  payload: string,
): RemoveOrganizationInviteAction => ({
  type: REMOVE_ORGANIZATION_INVITE,
  payload,
})

export type RemoveOrganizationInviteActions = RemoveOrganizationInviteAction
